import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

const FloatingButtons = () => {
  return (
    <div className="floating-container-left">
      {/* Üstte: WhatsApp Baloncuğu */}
      <a
        href="https://wa.me/905352439955?text=Merhaba,%20nakliye%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn shadow-lg"
        title="WhatsApp'tan Yazın"
      >
        <FaWhatsapp size={28} />
      </a>

      {/* Altta: Arama Baloncuğu */}
      <a
        href="tel:+905352439955"
        className="floating-btn call-btn shadow-lg"
        title="Bizi Arayın"
      >
        <FaPhoneAlt size={22} />
      </a>
    </div>
  );
};

export default FloatingButtons;